import { create } from 'zustand';

export const useCalculateStore = create((set) => ({
  carbonPrice: 0,
  cbamFactor: 97.5,
  carbonPriceHydrated: false,
  defaultValues: false,

  setCarbonPrice: (carbonPrice) =>
    set(() => ({
      carbonPrice,
      carbonPriceHydrated: true,
    })),
  setCbamFactor: (cbamFactor) => set({ cbamFactor }),
  setDefaultValues: (defaultValues) => set({ defaultValues }),
}));
